<cipo-dialog-header title="assignments.selectUsers" [closeResult]="[]" />
<mat-dialog-content>
    <div class="p-t-md cipo--height--full">
        <cipo-searchable-listbox [(values)]="listBoxValues" [config]="listBoxConfig()" [options]="listBoxOptions()">
            <div fxLayoutGap="4px" fxLayoutAlign="start start" class="cipo-text--bold-sm cipo-text--black-400 m-b-md">
                <mat-icon fxFlex="none" class="cipo-icon cipo-icon--sm material-symbols-outlined">info</mat-icon>
                <span fxLayout="row wrap">
                    {{ "assignments.cascadeInfo" | translate }}
                </span>
            </div>
        </cipo-searchable-listbox>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="[]">{{ "general.close" | translate }}</button>
    <button mat-raised-button color="primary" (click)="returnUsers()">
        {{ "general.save" | translate }}
    </button>
</mat-dialog-actions>
